$(document).ready(function () {
    $(".loadmore").on("click", function (e) {
        e.preventDefault();
        load_more();
    });

    $(".thematique").on("click", function (e) {
        e.preventDefault();
        load_theme($(this));
        if ($(".thematique.is-inactive").length === 0) {
            $(".thematique").addClass("is-inactive");
        }
        $(".thematique.is-active")
            .removeClass("is-active")
            .addClass("is-inactive");
        $(this).removeClass("is-inactive").addClass("is-active");
    });

    $(".cat_thematique").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("inactive")) {
            $(".c-filter-featured.active")
                .removeClass("active")
                .addClass("inactive");
            $(this).removeClass("inactive").addClass("active");

            var parent_url = $(".cat_thematique.all").attr("href");
            window.history.pushState("", null, parent_url);

            $("h1 .active_child").html($(this).data("title"));
            if (!$(this).data("title") == "")
                $(".title--page").addClass("has-children");
            else $(".title--page").removeClass("has-children");

            change_theme($(this));
        }
    });

    //------------------------------------------------------------------------------------
    // FONCTIONS
    //------------------------------------------------------------------------------------

    function load_more() {
        var nb_post_to_display = $(".loadmore").data("nb-post-to-display");
        var nb_post_displayed = $(".loadmore").data("nb-post-displayed");
        var nb_post_total = $(".loadmore").data("nb-post-total");
        var exclude_post = $(".loadmore").data("ex-post");
        var filtre_cat = $(".loadmore").data("tax");
        var filtre_author = $(".loadmore").data("author"); //console.log(filtre_author);
        var filtre_authors = $(".loadmore").data("authors");
        var search = $(".loadmore").data("s");
        var loop_format = $(".loadmore").data("loopformat");
        var loop_type = $(".loadmore").data("looptype");
        $(".grid-append-content").addClass("loading");
        if (
            !nb_post_total ||
            (nb_post_total && nb_post_total > nb_post_displayed)
        ) {
            $(".loadmore").addClass("is-active");
            $.ajax({
                url: wami_js.ajaxurl,
                data: {
                    action: "wami_loadmore_and_filtre_posts",
                    nb_post_to_display: nb_post_to_display,
                    exclude_post: exclude_post,
                    filtre_cat: filtre_cat,
                    filtre_author: filtre_author,
                    filtre_authors: filtre_authors,
                    search: search,
                    loop_format: loop_format, 
                    loop_type: loop_type,
                },
                success: function (data) {
                    var obj = jQuery.parseJSON(data);
                    //console.log(obj);
                    if ($(".grid-append-content > .skeleton:first").length) {
                        //console.log('skeleton exist');
                        $(obj.content).insertBefore(
                            ".grid-append-content > .skeleton:first"
                        );
                        $(".grid-append-content").removeClass("loading");
                    } else {
                        $(".grid-append-content")
                            .append(obj.content)
                            .removeClass("loading");
                    }
                    nb_post_displayed = nb_post_displayed + nb_post_to_display;
                    if (nb_post_total && nb_post_displayed >= nb_post_total)
                        $(".loadmore").remove();
                    $(".loadmore").data("nb-post-displayed", nb_post_displayed);
                    $(".loadmore").data("ex-post", obj.post_to_exclude);
                    $(".loadmore").removeClass("is-active");
                    lazyLoadInstance.update();
                    if ($(".playlist_videos").length) active_video();
                },
                error: function (errorThrown) {
                    console.log("erreur de chargement");
                },
            });
        }
    }

    function change_theme(button) {
        var nb_post_to_display = button.parent().data("nb-post-to-display");
        var nb_post_to_display_after = button
            .parent()
            .data("nb-post-to-display-after");
        var filtre_cat = button.data("tid");
        var moreread = button.hasClass("moreread") ? button.data("time") : 0;
        var loop_type = button.parent().data("looptype");
        $(".grid-featured-content, .grid-append-content, .js-theme").addClass("loading");
        $(".grid-featured-content").html("");
        var skeletons_append_content = $('.skeletons-for-grid-append-content').html();
        $(".grid-append-content").html(skeletons_append_content);
        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: "wami_change_posts",
                nb_post_to_display: nb_post_to_display,
                nb_post_to_display_after: nb_post_to_display_after,
                filtre_cat: filtre_cat,
                moreread: moreread,
                loop_type: loop_type,
            },
            success: function (data) {
                var obj = jQuery.parseJSON(data); //console.log(obj); 
                $(".grid-featured-content")
                    .html(obj.featuredcontent)
                    .removeClass("loading");
                $(".grid-append-content")
                    .html(obj.aftercontent)
                    .removeClass("loading");              
                $(".js-theme").removeClass("loading");
                $(".loadmore").data("ex-post", obj.post_to_exclude);
                $(".loadmore").data("tax", filtre_cat);
                if ($(".js-tns-category")) {
                    categorySlider.rebuild();
                }
                lazyLoadInstance.update();
            },
            error: function (errorThrown) {
                console.log("erreur de chargement");
            },
        });
    }

    function load_theme(button) {
        var filtre_cat              = button.data("tid");
        var filtre_cat_name         = button.html();
        var filtre_cat_link         = button.attr("href");
        var filtre_cat_followed     = button.data("followed"); 
        //console.log(filtre_cat_name+' ('+filtre_cat+') : '+filtre_cat_followed);
        var $loop_format            = button.data("loopformat");        
        var nb_post_to_display      = button.data("nb-post-to-display");
        var exclude_post            = button.data("ex-post");
        if ($(".loadmore").lenght) exclude_post = $(".loadmore").data("ex-post");        
        thematiqueSlider.destroy();
        var skeleton                = $(".skeletons-for-grid-filter-content").html();
        $(".grid-filter-content").html(skeleton).addClass("loading");
        $.ajax({
            url: wami_js.ajaxurl,
            data: {
                action: "wami_loadmore_and_filtre_posts",
                nb_post_to_display: nb_post_to_display,
                exclude_post: exclude_post,
                filtre_cat: filtre_cat,
                follow_cat: true,
                filtre_cat_name: filtre_cat_name,
                filtre_cat_link: filtre_cat_link,
                loop_format: $loop_format,
            },
            success: function (data) {
                var obj = jQuery.parseJSON(data);
                $(".grid-filter-content").html(obj.content).removeClass("loading");               
                //$(".thematique_name").html(filtre_cat_name);
                //$(".thematique_link").attr("href", filtre_cat_link);
                //$(".thematique_link").attr("data-tid", filtre_cat); 
                /*if(filtre_cat_followed == 'unfollow-cat') {
                    $('.js-follow-cat').addClass('u-hide').removeClass('u-show');
                    $('.js-unfollow-cat').addClass('u-show').removeClass('u-hide');
                    button.attr("data-followed", 'follow-cat');
                }
                else {                    
                    $('.js-unfollow-cat').addClass('u-hide').removeClass('u-show');
                    $('.js-follow-cat').addClass('u-show').removeClass('u-hide');
                    button.attr("data-followed", 'unfollow-cat');
                }*/
                $('.js-filters_follow.active').addClass("u-hide").removeClass("active");
                $('.js-filters_follow.tid-'+filtre_cat).removeClass('u-hide').addClass("active");
                if ($(".js-tns-thematique")) {
                    thematiqueSlider = tns({
                        container: ".js-tns-thematique",
                        items: 1,
                        slideBy: 1,
                        loop: true,
                        autoplay: false,
                        controls: false,
                        center: true,
                        gutter: 15,
                        navPosition: "bottom",
                        responsive: {
                            500: {
                                // gutter: 15,
                                // items: 2,
                                disable: true,
                            },
                            960: {
                                disable: true,
                            },
                        },
                    });
                }
                lazyLoadInstance.update();
            },
            error: function (errorThrown) {
                console.log("erreur de chargement");
            },
        });
    }

    if ($(".single_file").length) {
        active_video();
    }

    function active_video() {
        var video_active = $(".single_file").data("pid");
        $(".playlist_videos")
            .find("#pid_" + video_active)
            .addClass("active");
    }
});
